import { Col, Row } from "react-bootstrap";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

export const ReturnOfGoodsFromCustomersDetailAdditional = () => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={12}>
                    <NFTextAreaInput
                        fieldName={"comment"}
                        title={t("Comment")}
                        required={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("CreatedUser")}
                        fieldName={"createdUser"}
                        disabled={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("CreatedDate")}
                        fieldName={"createdDate"}
                        disabled={true}
                    />
                </Col>
            </Row>
        </>
    );
};
